const customColors = {
    primaryEmkay: '#18576c',
}
export default customColors;